import _toConsumableArray from "@babel/runtime-corejs2/helpers/esm/toConsumableArray";
import _classCallCheck from "@babel/runtime-corejs2/helpers/esm/classCallCheck";
import { assertListeners } from './utils';

var TrackAnalytics = function TrackAnalytics(listeners) {
  var _this = this;

  _classCallCheck(this, TrackAnalytics);

  this.trackingHistory = [];

  this.on = function (eventType, callback) {
    // eslint-disable-next-line no-param-reassign
    callback.eventType = eventType;
    _this.listeners = _toConsumableArray(_this.listeners).concat([callback]);
  };

  this.trackEvent = function (event) {
    var _ref = event || {},
        type = _ref.type;

    if (type) {
      for (var i = 0; i < _this.listeners.length; i += 1) {
        var listener = _this.listeners[i];

        if (typeof listener === 'function' && (listener.eventType === type || listener.eventType === '*')) {
          var save = listener.call(null, event, _this.trackingHistory);

          if (save) {
            _this.trackingHistory = _toConsumableArray(_this.trackingHistory).concat([save]);
          }
        }
      }
    }
  };

  this.getHistory = function () {
    return _this.trackingHistory;
  };

  this.listeners = assertListeners(listeners);
};

export default TrackAnalytics;